export default __webpack_public_path__ + "static/media/img_thank_you.43570a4a.png";